import { Decamelized } from 'humps'
import { toCamelCase } from 'shared/helpers/utils'
import { Truck } from 'shared/models/truck'

import { getRequest } from '../api/common'

export type TruckV1 = Decamelized<Truck>

export function getTruckV1(id: string | undefined): Promise<{ truck: Truck | undefined }> {
  return getRequest(`/api/v1/console/trucks/${id}/`).then((data) => ({
    truck: data ? (toCamelCase(data) as Truck) : undefined,
  }))
}
